var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterestLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pinterest",
    clipPath: "url(#clip0_250_18061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.09 46.2791C14.79 43.5498 15 40.9404 15.6 38.421L18 28.0734C17.61 26.8137 17.31 25.3741 17.31 23.9344C17.31 20.5752 18.93 18.1757 21.48 18.1757C23.25 18.1757 24.5401 19.4055 24.5401 21.7749C24.5401 22.5248 24.39 23.3645 24.09 24.3243L23.04 27.7735C22.83 28.4333 22.74 29.0632 22.74 29.6031C22.74 32.0026 24.57 33.3522 26.91 33.3522C31.08 33.3522 34.05 29.0332 34.05 23.4245C34.05 17.186 29.97 13.1968 23.94 13.1968C17.22 13.1968 12.96 17.5759 12.96 23.6645C12.96 26.1239 13.71 28.4033 15.18 29.963C14.7 30.7728 14.19 30.9227 13.41 30.9227C11.01 30.9227 8.72995 27.5335 8.72995 22.9146C8.72995 14.9365 15.12 8.57799 24.09 8.57799C33.51 8.57799 39.42 15.1465 39.42 23.2444C39.42 31.4025 33.66 37.5212 27.45 37.5212C24.99 37.5212 22.83 36.4714 21.33 34.5818L20.1 39.5607C19.44 42.14 18.45 44.5694 16.86 46.9088C19.11 47.5988 21.33 47.9887 24 47.9887C37.26 47.9887 48 37.2512 48 23.9943C48 10.7374 37.26 0 24 0C10.74 0 0 10.7375 0 23.9944C0 34.0421 6.18 42.7099 15.09 46.2791Z",
    fill: "#E51E27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_18061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestLogo);
export default __webpack_public_path__ + "static/media/pinterest-logo.cef1d530378bb55d74188a098d861ed4.svg";
export { ForwardRef as ReactComponent };